// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"e935b1e4","412":"926b679f","766":"e935b1e4","821":"bd3f20ce"}[chunkId] + ".chunk.js";
};